"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
const react_1 = require("react");
const React = require("react");
require("./menu.less");
class Menu extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleActionClick = (row) => (event) => {
            event.stopPropagation();
            this.props.onAction(row);
        };
    }
    render() {
        const { alignItems = "left", className, data = [] } = this.props;
        const active = this.props.showMenu ? " menu-component--active" : "";
        return (React.createElement("div", { className: `menu-component menu-component--${alignItems}${active} ${className}`, tabIndex: 0 },
            this.props.children,
            this.renderMenu(alignItems, data)));
    }
    renderMenu(alignItems, data) {
        return (React.createElement("div", { className: `menu menu--${alignItems}` }, this.props.showMenu &&
            data.map(row => this.renderRow(alignItems, row))));
    }
    renderRow(alignItems, row) {
        return (React.createElement("a", { className: `menu__item menu__item--${alignItems}`, key: row.id, onMouseDown: this.handleActionClick(row), style: { backgroundColor: row.disable ? "" : "#cbcbcd" } },
            React.createElement("div", { className: "menu-item__icon" }, row.icon),
            React.createElement("div", { className: "menu-item__name" }, row.label)));
    }
}
exports.Menu = Menu;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/menu/menu.tsx
// module id = 2702
// module chunks = 0 1